import { render, staticRenderFns } from "./CandidateSkillsKnowledges.vue?vue&type=template&id=772179ce&scoped=true"
import script from "./CandidateSkillsKnowledges.vue?vue&type=script&lang=js"
export * from "./CandidateSkillsKnowledges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772179ce",
  null
  
)

export default component.exports